import { render, staticRenderFns } from "./OneClickCheckoutSummaryLoading.vue?vue&type=template&id=646af788&scoped=true&"
import script from "./OneClickCheckoutSummaryLoading.vue?vue&type=script&lang=js&"
export * from "./OneClickCheckoutSummaryLoading.vue?vue&type=script&lang=js&"
import style0 from "./OneClickCheckoutSummaryLoading.vue?vue&type=style&index=0&id=646af788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646af788",
  null
  
)

export default component.exports